import React from 'react';
import NavbarBlock from '../cms/blocks/types/NavbarBlock';
import { useGlobals } from '../cms/useGlobals';

/**
 * Navbar — thin wrapper around the CMS NavbarBlock. Reads globals from the
 * cached useGlobals hook (currently seeded from src/cms/seed.json).
 *
 * TODO: move globals to backend `/api/website-cms/globals` and update
 * useGlobals to fetch from there.
 */
const Navbar = () => {
  const globals = useGlobals();
  const data = globals?.navbar?.data || globals?.navbar;
  if (!data) return null;
  return <NavbarBlock data={data} editing={false} />;
};

export default Navbar;
